import * as React from 'react';
import styled from 'styled-components';

interface IWrapperProps {
	background_image: string;
}


const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0;
  width: 100%;

  @media (min-width: 1200px) {
	flex-direction: row;
	padding-bottom: 30px;
	align-self: stretch;
	align-items: flex-start;
  }

  &:last-child {
	> div:last-child {
	  display: none;
	}
  }
`;

const ContentWrapper = styled.div<IWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  text-align: center;
  height: 100%;
  //justify-content: space-between;
  //background-repeat: no-repeat;
	//background-image: url(${({background_image}) => background_image});
  //background-position: center top;

  //padding-top: 95px;
  //background-size: auto 70px;

  img {
	max-width: 150px;
	height: 150px;
	margin-bottom: 30px;
  }

  //@media (min-width: 1200px) {
  //	padding-top: 165px;
  //	background-size: auto 140px;
  //}

  @media screen and (max-width: 1000px) {
	padding-left: 0;
	padding-right: 0;

	img {
	  max-width: 75px;
	  height: unset;
	}
  }
`;

const Title = styled.div`
  color: #38312D;
  text-transform: uppercase;
  font-family: Champion, sans-serif;
  font-size: 60px;
  letter-spacing: 0;
  line-height: 60px;
  text-align: center;
  max-width: 305px;

  span {
	color: #FEC600;
  }

  @media (min-width: 1200px) {
	min-height: 110px;
	font-size: 60px;
  }

  @media screen and (max-width: 1000px) {
	font-size: 34px;
	letter-spacing: 0;
	line-height: 34px;
	text-align: center;
	padding: 0 50px;
  }
`;

const Text = styled.div`
  font-family: Eund, sans-serif;
  color: #595959;
  max-width: 235px;
  margin-top: 20px;
  line-height: 20px;
  font-weight: 22;
  letter-spacing: 0;
  text-align: center;

  @media (min-width: 1200px) {
	font-size: 18px;
	line-height: 28px;
	font-weight: 400;
  }

  @media screen and (max-width: 1000px) {
	display: none;
  }
`;

const Rule = styled.div`
  background-color: #FFC600;
  width: 200px;
  height: 6px;
  margin-top: 20px;
  margin-bottom: 40px;
  position: absolute;
  right: 0;

  @media (min-width: 1200px) {
	margin: 0;
	width: 6px;
	min-height: 315px;
	align-self: center;
  }

  @media screen and (max-width: 1000px) {
	position: relative;
	left: unset;
	top: unset;
  }
`;

interface IProps {
	icon: string;
	text?: string;
}

export const LandingTile: React.FC<IProps> = ({icon, text, children}) => (
	<Wrapper>
		<ContentWrapper background_image={icon}>
			<img src={icon} alt={'Prize icon'}/>
			<Title>{children}</Title>
			{text && (<Text>{text}</Text>)}
		</ContentWrapper>
		<Rule/>
	</Wrapper>
);
